import React from 'react'
import TextField from '@liveramp/motif/core/TextField'

export default function DatePickerDemo() {
  return (
    <TextField id="date" label="Date" type="date" defaultValue="2021-07-12" />
  )
}
